<template>
  <Card>
    <template v-slot:title>
      <Skeleton width="50%" height="25px" />
    </template>
    <template v-slot:content>
      <AppSkeletonTable></AppSkeletonTable>
    </template>
  </Card>
</template>

<script>
import AppSkeletonTable from './AppSkeletonTable';

export default {
  name: 'AppSkeletonCardTable',
  components: {
    AppSkeletonTable,
  },
};
</script>

<style scoped>
.p-card-content {
  margin-top: 0 !important;
}
</style>